export default class Customer {
  public id: string;
  public name: string;
  public created: number;
  public delinquent: boolean;
  public email: string;
  public deleted = false;

  constructor(options) {
    this.id = options.id;
    this.name = options.name;
    this.created = options.created;
    this.delinquent = options.delinquent;
    this.email = options.email;
    if (options.deleted) {
      this.deleted = options.deleted;
    }
  }
}
